import Inspector from './inspector'
const { RichText } = wp.blockEditor
const staticDefaultImage = 'https://via.placeholder.com/830x250';

const Edit = ({ attributes, setAttributes }) => {
  const { cardTitle, image, buttonText } = attributes

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />
      <div className="CardContent">
        <figure className='CardContent-image'>
          <img src={image.src || staticDefaultImage } class='MainFeatured-news-image' />
        </figure>

        <div className="CardContent-info">        
          <RichText
            tagName='span'
            className='CardContent-title'
            value={cardTitle}
            placeholder='Texto aqui'
            keepPlaceholderOnFocus
            onChange={cardTitle => setAttributes({ cardTitle })}
          />

          <RichText
            tagName='span'
            className='CardContent-button'
            value={buttonText}
            placeholder='Comprar na loja'
            keepPlaceholderOnFocus
            onChange={buttonText => setAttributes({ buttonText })}
          />
        </div>
      </div>
    </>
  )
}

export default Edit
